import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Award, CheckCircle2, Clock, AlertTriangle } from 'lucide-react';

const VERDE = '#10B981';
const AMBAR = '#F59E0B';
const AZUL = '#0369A1';
const ROJO = '#DC2626';
const GRIS = '#6B7280';

export default function AvanceCiclo() {
  const [ciclos, setCiclos] = useState(null);

  useEffect(() => {
    api.get('/client/mi-ciclo')
      .then((r) => setCiclos(r.data?.ciclos || []))
      .catch(() => setCiclos([]));
  }, []);

  if (!ciclos || !ciclos.length) return null;

  return (
    <div style={{ display: 'grid', gap: 14, marginBottom: 24 }}>
      {ciclos.map((c, i) => {
        const listo = c.listo;
          const suspendido = c.estado_distintivo === 'suspendido';
          const observacion = c.estado_distintivo === 'observacion';
          const color = suspendido ? ROJO : observacion ? AMBAR : c.distintivo_emitido ? VERDE : listo ? AMBAR : AZUL;
          const Ic = suspendido || observacion ? AlertTriangle : c.distintivo_emitido ? CheckCircle2 : listo ? Award : Clock;
        return (
          <div key={`${c.distintivo_code}-${i}`} style={{ border: '1px solid #E5E7EB', borderRadius: 12,
            padding: 20, background: '#FFF' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              marginBottom: 15 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                <Award size={19} color={color} />
                <span style={{ fontWeight: 700, fontSize: 15.5 }}>
                  Tu avance hacia el Distintivo {String(c.distintivo_code || '').replaceAll('AIGIS-', '')}
                </span>
              </div>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5,
                padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                background: color + '18', color }}>
                <Ic size={13} /> {c.etapa}
              </span>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13,
              color: GRIS, marginBottom: 7 }}>
              <span><b style={{ color: '#1A1A1A', fontSize: 15 }}>{c.aprobadas}</b> de {c.requeridas} auditorías aprobadas seguidas</span>
              {c.promedio != null && <span>promedio {c.promedio}%</span>}
            </div>

            <div style={{ height: 11, background: '#F0F1F3', borderRadius: 7, overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${Math.min(100, c.porcentaje)}%`,
                background: color, borderRadius: 7, transition: 'width .4s' }} />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 7,
              fontSize: 11, color: '#9AA0A6' }}>
              {[...Array(c.requeridas || 3)].map((_, n) => (
                <span key={n} style={{ color: n < c.aprobadas ? color : '#D6D9DC',
                  fontWeight: n < c.aprobadas ? 700 : 400 }}>{n + 1}</span>
              ))}
            </div>

            <div style={{ marginTop: 14, padding: 13, background: color + '0D',
              borderLeft: '3px solid ' + color, borderRadius: 6, fontSize: 13.5,
              lineHeight: 1.5, color: '#2A2F35' }}>
              {c.mensaje}
            </div>

            {!c.distintivo_adquirido && (
              <div style={{ marginTop: 11, fontSize: 12, color: GRIS }}>
                Con 3 auditorías aprobadas seguidas adquieres tu distintivo.
                Si una no se aprueba, el conteo vuelve a cero.
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
